let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ijyQj")).then(() => parcelRequire('9E78Q'));